var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSchedulerRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.216 11.28C0.36 11.424 0.536 11.496 0.744 11.496C0.952 11.496 1.128 11.424 1.272 11.28L6.288 6.288C6.432 6.128 6.504 5.948 6.504 5.748C6.504 5.548 6.432 5.368 6.288 5.208L1.272 0.216C1.128 0.072 0.952 0 0.744 0C0.536 0 0.36 0.072 0.216 0.216C0.072 0.36 0 0.536 0 0.744C0 0.952 0.072 1.128 0.216 1.272L4.68 5.76L0.216 10.224C0.072 10.368 0 10.544 0 10.752C0 10.96 0.072 11.136 0.216 11.28Z",
    fill: "#2A4D82"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedulerRight);
export default __webpack_public_path__ + "static/media/scheduler-right.2f21996d.svg";
export { ForwardRef as ReactComponent };